var showAnimation = {
	init: function() {
		this.setParameter();
		this.bindEvent();
		this.setAnimation();
	},
	setParameter: function() {
		this.$target = $('#js-article-list');
		this.$targetList = this.$target.find('.js-article').filter(function () {
			return $(this).hasClass('isOpacityNone');
		});
		$('.js-loading').css('opacity', '0');
	},
	bindEvent: function () {
		this.$targetList.on('animationend.bounceIn', function () {
			$(this).removeClass('isOpacityNone');
		});
	},
	setAnimation: function () {
		var endCount = 0,
			that = this;

		var repeat = setInterval(function () {
			if (endCount >= that.$targetList.length) {
				clearInterval(repeat);
			} else {
				that.$targetList.eq(endCount).addClass('bounceIn');
				endCount++;
			}
		}, 50);
	}
};

module.exports = showAnimation;


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/show_animation.js
 ** module id = 1
 ** module chunks = 8
 **/